import React from 'react';
import { sanitize } from 'utils/validation';
import Modal from 'components/Modal';
import MODAL, { MODAL_THEMES } from 'constants/modals';

const GenericGboCopyModal = () => (
  <Modal modalKey={MODAL.EXTRAS_EXCLUSION_MODAL} theme={MODAL_THEMES.WHITE}>
    {({ gboCopy, modalKey = '' }) => (
      <div id={`${modalKey}_desc`} className='modal-themed__gbo-content' dangerouslySetInnerHTML={sanitize(gboCopy)} />
    )}
  </Modal>
);

export default GenericGboCopyModal;
